// A prompt version is intentionally immutable once a clinic has saved it. This per-run addendum
// therefore carries the safety rules that make a context-only generation work even for versions
// written before that capability existed.

export interface ContextOnlyReportPromptOptions {
  readonly consultation: Record<string, unknown>;
  readonly interfaceLanguage: string;
  readonly hasTemplate: boolean;
}

export function appendContextOnlyReportInstruction(
  prompt: string,
  options: ContextOnlyReportPromptOptions,
): string {
  const languageRule = options.hasTemplate
    ? 'La plantilla determina el idioma de los fragmentos que redactes.'
    : `No hay plantilla: responde en el idioma activo de la interfaz (${options.interfaceLanguage}).`;

  return (
    `${prompt.trimEnd()}\n\nModo sin notas:\n` +
    'No hay notas clínicas seleccionadas. Usa exclusivamente la ficha y los datos estructurados ' +
    'de la consulta (JSON) como fuente clínica; no infieras ni completes datos ausentes. No señales ' +
    'la ausencia de notas como un dato no encontrado ni como una inconsistencia. "inconsistencias" ' +
    'debe quedar vacío. Cuando el esquema pida "citaTextual", copia literalmente el valor que lo ' +
    `respalda en el JSON. ${languageRule}\n\nContexto estructurado de la consulta:\n` +
    JSON.stringify(options.consultation)
  );
}
